// extracted by extract-css-chunks-webpack-plugin
module.exports = {"root":"styles__root__11SoN"};